export const EXPORT = {
  REQUEST: 'Catalog/Export/Request',
  SUCCESS: 'Catalog/Export/Success',
  FAILURE: 'Catalog/Export/Failure'
};

export const UPLOAD = {
  REQUEST: 'Catalog/Uploda/Request',
  SUCCESS: 'Catalog/Uploda/Success',
  FAILURE: 'Catalog/Uploda/Failure'
};

export const FORSUBMIT = {
  REQUEST: 'Catalog/ForSubmit/Request',
  SUCCESS: 'Catalog/ForSubmit/Success',
  FAILURE: 'Catalog/ForSubmit/Failure'
};
